module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "divFooter"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-12"
  }, [_c('p', [_vm._v("Copyright © 2019 "), _c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "https://www.epapersign.com",
      "target": "_blank"
    }
  }, [_vm._v("ePaper LTD")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('small', [_vm._v("Developed by "), _c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "https://www.epapersign.com",
      "target": "_blank"
    }
  }, [_vm._v("ePaper LTD")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-775bf690!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/footer.vue
// module id = 728
// module chunks = 0